import { useState } from "react";

/**
 * 能力画像相关状态管理 Hook
 */
const useCapabilityProfileState = () => {
  const [showCapabilityProfileIcon, setShowCapabilityProfileIcon] = useState(false);
  const [currentStudentId, setCurrentStudentId] = useState(null);
  const [capabilityLevel, setCapabilityLevel] = useState('unknown');
  const [capabilityLevelDetails, setCapabilityLevelDetails] = useState(null);
  const [shouldBlinkCapabilityIcon, setShouldBlinkCapabilityIcon] = useState(false);

  // 批量更新能力画像状态
  const updateCapabilityProfileState = (data) => {
    if (data.showIcon !== undefined) setShowCapabilityProfileIcon(data.showIcon);
    if (data.studentId !== undefined) setCurrentStudentId(data.studentId);
    if (data.level !== undefined) setCapabilityLevel(data.level);
    if (data.levelDetails !== undefined) setCapabilityLevelDetails(data.levelDetails);
    if (data.shouldBlink !== undefined) setShouldBlinkCapabilityIcon(data.shouldBlink);
  };

  // 重置能力画像状态
  const resetCapabilityProfileState = () => {
    setShowCapabilityProfileIcon(false);
    setCurrentStudentId(null);
    setCapabilityLevel('unknown');
    setCapabilityLevelDetails(null);
    setShouldBlinkCapabilityIcon(false);
  };

  return {
    showCapabilityProfileIcon,
    setShowCapabilityProfileIcon,
    currentStudentId,
    setCurrentStudentId,
    capabilityLevel,
    setCapabilityLevel,
    capabilityLevelDetails,
    setCapabilityLevelDetails,
    shouldBlinkCapabilityIcon,
    setShouldBlinkCapabilityIcon,
    updateCapabilityProfileState,
    resetCapabilityProfileState,
  };
};

export default useCapabilityProfileState;
